import Hotspot from "./hotspot";
import Marzipano from 'marzipano';
import SceneList from "./sceneList";
import Move from "./hotspots/move";


class Scene {
    constructor({ image, cameraPos, viewer, cameraStart, name = "", setActual = () => {

    }}) {

        this.cameraPos = cameraPos;
        this.image = image;
        this.cameraCord = cameraStart;
        this.name = name;

        this.params = {
            geometry: new Marzipano.EquirectGeometry([{ width: 6000 }]),
            view:   new Marzipano.RectilinearView({ pitch : 0 , yaw:0,fov : Math.PI/2.2 ,...cameraStart}, Marzipano.RectilinearView.limit.vfov(.5, Math.PI/2.2))
        }

        this.setActual = setActual;
        this.hotspots = [];
        this.scene = this.createScene(viewer);
        this.cameraInit();

    

    }


    addHotspot(hotspot,toList = true) {
        this.scene.hotspotContainer().createHotspot(hotspot.getHotspot(), hotspot.position);

        if (hotspot instanceof Move && toList)
            this.hotspots.push(hotspot);
    }


    createMenu() {

        return <SceneList remove={false} variation='right' title={"Blisko Ciebie"} actualScene={this.scene} scenes={this.hotspots.map((e) => {
            return {scene : e.target,hint :e.hint }
        })}
            className='fixed z-50 p-2 flex flex-col gap-2 left-0' expanded={true}></SceneList>

    }


    cameraInit() {
        if (this.cameraCord !== null) {

        }
    }

    createScene(viewer) {
        var source = Marzipano.ImageUrlSource.fromString(
            `${process.env.PUBLIC_URL}/${this.image}`
        );

        const scene = viewer.createScene({
            source: source,
            ...this.params
        });
        return scene;
    }

    loadScene(cameraPos = null) {
        this.setActual(this);
        this.scene.switchTo();
        if (cameraPos !== null) {
            console.log(cameraPos);
            this.scene.lookTo(cameraPos, { transitionDuration: 0 })
        }
    }
}


export default Scene